<!--
  - Copyright (c) 2023. Haodong JU
  -->

<template>
  <v-card
    v-if="frontPrintGroupInfo"
    class="pa-4"
    elevation="0"
    height="356"
  >
    <div
      class="d-flex align-center"
      style="height: 24px"
    >
      <v-spacer />
    </div>
    <template>
      <v-card
        class="my-2"
        color="transparent"
        flat
      >
        <v-card
          class="d-flex align-center justify-center"
          color="transparent"
          flat
          height="196"
        >
          <div
            class="px-8 py-4 text-center"
            flat
          >
            <v-icon size="60">
              mdi-store-check
            </v-icon>
          </div>
        </v-card>
        <div class="d-flex align-center justify-center flex-column text-body-2">
          <div
            class="text-body-1 textNoWrap font-weight-bold"
          >
            {{ $t('Frontprinter') }}
          </div>
          <div
            v-if="frontPrintGroupInfo.printers.length===0"
            class="textNoWrap text-caption mt-1"
            style="display: flex; text-align: center"
          >
            {{ $t('FrontprinterHint') }}
          </div>
          <div
            v-else
            class="textNoWrap text-caption mt-1"
            style="display: flex; text-align: center"
          >
            {{ $t('CurrentSelected') }}: {{ frontPrintGroupInfo.printers[0].printerName }} {{ $t('AsReceiptPrinter') }}
            / {{
              $t('printerCount', { printerCount: frontPrintGroupInfo.totalDishesCount })
            }}
          </div>
          <v-btn
            v-if="frontPrintGroupInfo.printers.length===0"
            class="mt-1"
            color="amber lighten-4 black--text"
            depressed
            small
            text
            @click="$emit('add')"
          >
            <v-icon left>
              mdi-plus
            </v-icon>
            {{ $t('CreateNewPrinter') }}
          </v-btn>
          <v-btn
            v-else
            class="mt-1"
            color="warning"
            depressed
            small
            text
            @click="$emit('add')"
          >
            <v-icon left>
              mdi-swap-horizontal
            </v-icon>
            {{ $t('ReplacePrinter') }}
          </v-btn>
        </div>
      </v-card>
    </template>
  </v-card>
</template>

<script>
import DeviceList from '@/model/dataLayer/api/print/DeviceList'
import PrinterGroup from '@/model/dataLayer/api/print/PrinterGroup'

export default {
  name: 'FrontGroupDeviceCard',
  data: function () {
    return {
      frontPrintGroupInfo: null
    }
  },
  async mounted () {
    const printers = await DeviceList.getList(true)
    const printGroup = await PrinterGroup.getList(true)
    this.frontPrintGroupInfo = printGroup.find(it => it.id === 3)
    if (this.frontPrintGroupInfo) {
      this.frontPrintGroupInfo.printers = printers.filter(it => it.groupId.includes(3))
    }
  }
}
</script>

<style scoped>

</style>
